import styled from "styled-components";

export const Table = styled.table`
  font-family: "Noto Sans", sans-serif;
  color: #000;
  width: 100%;
  margin-bottom: 1rem;
`;

export const THead = styled.thead`
  & > tr {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-right: 1rem;
    z-index: 998;

    & > td {
      display: flex;
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
      
      &.bigTd {
        min-width: 8rem;
      }

      & > div {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 4rem;
      }

      &:first-child {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        font-size: 1.25rem;
        font-weight: 600;
        min-width: 11rem;
        margin-right: 1.05rem;
        & > img {
          margin-right: 0.5rem;
          height: 1.5rem;
        }
      }
    }

    .total {
      font-weight: bold;
    }
  }

  &.sticky {
    position: sticky;
    z-index: 998;
    top: 206px;
    background: white;
    height: 40px;
    box-shadow: 0px 10px 15px -10px rgba(0, 0, 0, 0.1);
  }
`;

export const TBody = styled.tbody`
  width: 100%;
  & > tr:first-child {
    margin-top: 0.5rem;
  }
`;

export const TableRow = styled.tr`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 4rem;
  padding: 1rem;
  box-shadow: 0px 10px 15px -10px rgba(0, 0, 0, 0.1);
  margin-bottom: 0.5rem;
  font-size: 1rem;
  width: 100%;

  &:hover {
    box-shadow: inset 4px 0px 0px 0px #575757,
      0px 4px 17px -2px rgba(0, 0, 0, 0.15);
  }

  & > td {
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: flex-start;
    white-space: nowrap;

    &.bigTd {
      min-width: 8rem;
    }

    & > div {
      width: 80%;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    &:first-child {
      min-width: 11rem;
      max-width: 11rem;
    }
  }

  .total-result {
    font-weight: bold;
  }
  
  .total-result-number {
    white-space: nowrap;
    position:relative;
    overflow: hidden;
  }

  .wrong-input {
    background: red;
    transition: opacity 0s;
    -webkit-transition: opacity 0s;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 80%;
  margin: auto;
  justify-content: flex-end;
  margin-bottom: 10rem;
  gap: 2rem;
  & button {
    min-width: 160px;
  }
`;

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
